import { p, pdf } from '@/content/blocks'
import type { Project } from '@/types/content'

const project: Project = {
  slug: 'whack-it',
  title: 'Whack-It!',
  summary: 'A redesign of Whack-a-Mole for ME100.',
  cover: { src: '/assets/Whack-it_assem.png', alt: 'CAD assembly of the Whack-It! toy' },
  tags: ['CAD', 'Design'],
  order: 3,
  blocks: [
    p('As part of the first year mechanical engineering course in Waterloo, we were tasked with designing toys as group for Spin Master while documenting our entire iterative design process. Attached below is the report documenting the progress of our toy design and how we were able to reach our end design.'),

    pdf('/assets/ME100_Toy_Design_Report.pdf', 'ME100 Toy Design Report'),
  ],
}

export default project
